import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import {
  Schedule as TimeIcon,
  MonetizationOn as CoinIcon,
} from "@mui/icons-material";
import { StageCardFormValues } from "@/types/Card";

type Props = {
  values: StageCardFormValues;
  thumbnailImage?: string; // already uploaded + resolved URL
};

const PreviewChip = ({
  label,
  icon,
  bg = "var(--secondary-100)",
}: {
  label: string;
  icon?: React.ReactNode;
  bg?: string;
}) => (
  <Chip
    label={label}
    variant="outlined"
    sx={{
      background: bg,
      borderColor: bg,
      borderRadius: 2,
      height: 28,
      fontWeight: 600,
      px: 1.5,
    }}
  />
);

const StageCardPreview: React.FC<Props> = ({ values, thumbnailImage }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* Thumbnail */}
      {thumbnailImage && (
        <Box
          component="img"
          src={thumbnailImage}
          alt="Thumbnail"
          sx={{
            width: "100%",
            height: 400,
            objectFit: "cover",
            borderRadius: 1,
          }}
        />
      )}

      {/* Title + sub-title */}
      <Typography variant="h6" fontWeight={700} fontFamily="Lexend">
        {values.title}
        {!!values.short_description && `: ${values.short_description}`}
      </Typography>

      {/* Chips */}
      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
        {/* Venue size */}
        <PreviewChip label={values.venue_size} bg="var(--primary-100)" />

        {/* Rank tier */}

        {/* Price */}
        <PreviewChip
          label={`$${values.price}`}
          icon={<CoinIcon sx={{ color: "var(--primary-600)" }} />}
          bg="var(--warning-200)"
        />

        {/* Duration */}
        {values.duration && (
          <PreviewChip
            label={`${values.duration} mins`}
            icon={
              <TimeIcon sx={{ color: "var(--primary-600)", fontSize: 16 }} />
            }
          />
        )}
      </Box>

      {/* Long description */}
      {values.description && (
        <Typography variant="body2" color="text.secondary">
          {values.description}
        </Typography>
      )}
    </Box>
  );
};

export default StageCardPreview;
